// extracted by mini-css-extract-plugin
export var brand = "_97-9";
export var compact = "_97-6";
export var extraSmall = "_97-7";
export var icon = "_97-0";
export var large = "_97-4";
export var light = "_97-1";
export var medium = "_97-5";
export var outline = "_97-b";
export var primaryDark = "_97-a";
export var primaryLight = "_97-8";
export var primaryModern = "_97-c";
export var success = "_97-2";
export var successSolid = "_97-3";